/*
 * Error Boundary configuration
 */
export default {
  errorMessage: "An error has occurred",
  handleError(error: string): void {
    // eslint-disable-next-line no-console
    console.error(error);
  },
  showMessage: true
};
